
let target = document.querySelector(".product-ticker");
let original_html = target.innerHTML;
let new_html = "<div class='product-ticker__items'>" + original_html + "</div>";
target.innerHTML = new_html;
target.innerHTML += new_html;

let tickerWidth = document.querySelector(".product-ticker__items").offsetWidth;
const tickerSpeed = tickerWidth > 640 ? 15 : 5;

let initDuration = tickerWidth / tickerSpeed;

const tickerTl = gsap.timeline({
  scrollTrigger: {
    trigger: ".product-ticker__items",
    start: 'bottom bottom+=100',
    end: 'top top-=100',
    onEnter: () => tickerTl.play(),
    onLeaveBack: () => tickerTl.pause(),
    onEnterBack: () => tickerTl.play(),
    onLeave: () => tickerTl.pause()
  }
});

tickerTl.to(".product-ticker__items", {
  duration: initDuration,
  xPercent: -100,
  ease: "none",
  repeat: -1
});
